// packages/shared-hooks/src/clients/usePatchClientLegalEntity.ts
//
// `PATCH /clients/:id/legal-entities/:legalEntityId` — edits `name` /
// `inn` / `requisites`. `type` is immutable post-create; the wire DTO
// excludes it. Backend rechecks INN length against the current type and
// rejects type-mismatched length with 400 VALIDATION_ERROR.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  ClientLegalEntitySchema,
  type ClientLegalEntity,
  type PatchClientLegalEntityInput,
} from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { clientsKeys } from './keys.js';

export function usePatchClientLegalEntity(clientId: string, legalEntityId: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<ClientLegalEntity, unknown, PatchClientLegalEntityInput>({
    mutationFn: (input) =>
      client.patch<ClientLegalEntity>(
        `/clients/${clientId}/legal-entities/${legalEntityId}`,
        input,
        {},
        ClientLegalEntitySchema,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: clientsKeys.detail(clientId) });
      void qc.invalidateQueries({ queryKey: clientsKeys.all });
    },
  });
}
